import Vue from "vue";
import Vuex from "vuex";
// 状态保持，防止数据刷新丢失
// 项目足够大时，将store进行拆分成若干moudle

import common from "./modules/common"; // 存放通用信息
import member from "./modules/member"; // member模块
import doctorappointment from './modules/doctorappointment' // 金牌医生模块

// 可按模块继续扩展...
// 注意：只有程序级状态/数据方可使用store
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    namespaced: true,
    common,
    member,
    doctorappointment
  },
});
